export interface Supplier {
  id: string;
  key: string;
  name: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  townCity: string;
  region: string;
  postCode: string;
  countryName: string;
  tel: string;
  fax: string;
  mobile: string;
  email: string;
  web: string;
  vatRegNo: string;
  currencyCode: string;
  bank: string;
  tax: string;
  paymentTerm: string;
  sellingCompany: string;
  accountCode: string;
  crmAccountCode: string;
  deliveryTerm: string;
  settlementTerm: string;
  modeOfTransport: string;
  port: string;
  priceList: string;
  purchaseRegion: string;
  nominalAccount: string;
  purchaseOrderEmail: string;
  purchaseOrderCCEmail: string;
  internal: string;
  shipper: string;
  manifestShipper: string;
  agent: string;
  clearingAgent: string;
  obsolete: string;
}
